import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { inject } from '@angular/core';
import { DataService } from '../services/data/data.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);


  if(authService.isLogIn() == false){
    router.navigate(['login'])
    return false;
  }

  return true;
};
export const authGuardSubmodule: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const dataService = inject(DataService);

  dataService.initializationMenu();
  if(authService.isLogIn() == false){
    router.navigate(['login'])
    return false;
  }
  return true;
};
